/**
 * Viri in licence — one section per publisher (anchor `#vir-<sourceId>`,
 * the target of every entry's »Vir« row): licence, attribution and the
 * publisher's page. No layer list here (Teo 2026-09-15) — the catalogue and
 * the KingCAD tree are where layers live. A jump list sits under the lead.
 */

import type { WikiSource } from '../../../shared/types/layerWiki.js';
import { docsCopy } from '../docsCopy.js';
import { esc, isHttpUrl } from '../docsHtml.js';
import type { DocsCatalogue } from '../docsModel.js';
import { sourceAnchorId } from '../docsRouter.js';

function renderSource(s: WikiSource): string {
  const c = docsCopy.viri;
  const licence = s.licence
    ? isHttpUrl(s.licenceUrl)
      ? `<a href="${esc(s.licenceUrl)}" target="_blank" rel="noopener noreferrer">${esc(s.licence)}</a>`
      : esc(s.licence)
    : esc(c.licencePerEntry);
  const attribution = s.attribution ? ` · ${esc(c.attribution)}: ${esc(s.attribution)}` : '';
  const site = isHttpUrl(s.url)
    ? `<a class="docs-source-link" href="${esc(s.url)}" target="_blank" rel="noopener noreferrer">${esc(c.sourceSite)}</a>`
    : '';
  return `
    <section id="${esc(sourceAnchorId(s.id))}" class="docs-vir">
      <div class="docs-source-short">${esc(s.short)}</div>
      <h2 class="docs-vir-name">${esc(s.name)}</h2>
      <div class="docs-vir-meta">${licence}${attribution}</div>
      ${site}
    </section>`;
}

export function renderViri(cat: DocsCatalogue): string {
  const c = docsCopy;

  const toc = `
    <nav class="docs-vir-toc" aria-label="${esc(c.viri.tocLabel)}">
      ${cat.sources.map((s) => `<a href="#${esc(sourceAnchorId(s.id))}">${esc(s.short)}</a>`).join('')}
    </nav>`;

  const sections = cat.sources.map((s) => renderSource(s)).join('');

  return `
    <div class="docs-viri">
      <div class="docs-eyebrow">${esc(c.viri.eyebrow)}</div>
      <h1 class="docs-page-title" tabindex="-1">${esc(c.viri.title)}</h1>
      <p class="docs-page-lead">${esc(c.viri.intro(cat.counts.sources, cat.counts.ownLicence))}</p>
      ${toc}
      ${sections}
    </div>`;
}
